/**
 * Class description
 *
 * Created: 2017-10-10
 * @author jonas
 */
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {DungeonQuest} from "../DungeonQuest";
import {TimelineLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {DungeonQuestReelController} from "../reel/DungeonQuestReelController";


export class DungeonQuestSpinController extends SpinController {
    private _shouldForceNearwin:boolean;

    constructor() {
        super();
    }

    protected onAllReelsSpinStarted():void {
        if(this._shouldForceNearwin) {
            EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_TRY_NEAR_WIN, 0));
            this._shouldForceNearwin = false;
        }
        super.onAllReelsSpinStarted();
    }

    protected startSpin():void {
        //This happens before data is received so nextMode will be mode once data arrives.
        if(DungeonQuest.freeSpinFeatureController.preSpinHasWin()) {
            const tl:TimelineLite = new TimelineLite();
            tl.add(DungeonQuest.freeSpinFeatureController.getPreSpinAnimation());
            tl.add(() => DungeonQuest.reelAreaEffectController.runSpinAnimation(0.8));
            EventHandler.dispatchEvent(new GameEvent(DungeonQuestReelController.ADD_SPIN_START_DELAY, 0, tl.totalDuration()));
            this._shouldForceNearwin = true;
        } else {
            this._shouldForceNearwin = false;
            DungeonQuest.reelAreaEffectController.runSpinAnimation(0.8);
        }
        super.startSpin();
    }
}